import React from 'react'
import { Text, NextModal as Modal } from '@components/UI'

const FullscreenModal = ({ maximize, close }) => {
  return (
    <Modal
      className='fullscreen'
      title='Enter fullscreen Mode'
      close={() => close()}
      actions={
        <div>
          <button className='yes' onClick={maximize}>
            Yes, enter fullscreen
          </button>
          <button className='no' onClick={() => close()}>
            No, keep it
          </button>
        </div>
      }
    >
      <Text>
        Other participant just entered fullscreen mode, would you like to go
        fullscreen as well?
      </Text>
    </Modal>
  )
}

export default FullscreenModal
